import { type ComponentType, lazy } from 'react';

function page<Module, Key extends keyof Module>(load: () => Promise<Module>, key: Key) {
  return lazy(async () => ({
    default: (await load())[key] as unknown as ComponentType<Record<string, unknown>>,
  })) as unknown as Module[Key];
}

const shell = () => import('./app-shell.tsx');
const login = () => import('../features/auth/login-page.tsx');
const registerPage = () => import('../features/auth/register-page.tsx');
const assets = () => import('../features/assets/assets-page.tsx');
const account = () => import('../features/auth/account-page.tsx');
const adminUsers = () => import('../features/admin/users-page.tsx');
const audience = () => import('../features/live/audience-pages.tsx');
const consolePage = () => import('../features/live/console-page.tsx');
const projector = () => import('../features/live/projector-page.tsx');
const remote = () => import('../features/live/remote-page.tsx');
const builder = () => import('../features/presentations/builder-page.tsx');
const presentations = () => import('../features/presentations/presentations-page.tsx');
const preview = () => import('../features/presentations/preview-page.tsx');
const report = () => import('../features/reports/report-page.tsx');
const sessions = () => import('../features/reports/sessions-page.tsx');
const topicDetail = () => import('../features/topics/topic-detail-page.tsx');
const topics = () => import('../features/topics/topics-page.tsx');

export const AppShell = page(shell, 'AppShell');
export const LoginPage = page(login, 'LoginPage');
export const RegisterPage = page(registerPage, 'RegisterPage');
export const AssetsPage = page(assets, 'AssetsPage');
export const AccountPage = page(account, 'AccountPage');
export const UsersPage = page(adminUsers, 'UsersPage');
export const AudiencePage = page(audience, 'AudiencePage');
export const JoinPage = page(audience, 'JoinPage');
export const ConsolePage = page(consolePage, 'ConsolePage');
export const ProjectorPage = page(projector, 'ProjectorPage');
export const RemotePage = page(remote, 'RemotePage');
export const PairPage = page(remote, 'PairPage');
export const BuilderPage = page(builder, 'BuilderPage');
export const PresentationsPage = page(presentations, 'PresentationsPage');
export const PreviewPage = page(preview, 'PreviewPage');
export const ReportPage = page(report, 'ReportPage');
export const SessionsPage = page(sessions, 'SessionsPage');
export const TopicDetailPage = page(topicDetail, 'TopicDetailPage');
export const TopicsPage = page(topics, 'TopicsPage');
